import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Typography } from '@mui/material'
import { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'
import DateFormat from '../../store/types/enums/DateFormat'
import {
  StyledMonthAndYearContainer,
  StyledMonthPicker,
  StyledMonthPickerIconButton,
} from '../../styles/MonthPickerStyles'

type LocalMonthPickerProps = {
  value: Dayjs
  onChange: (date: Dayjs) => void
}

const LocalMonthPicker = ({ value, onChange }: LocalMonthPickerProps) => {
  const { i18n } = useTranslation()

  const handlePrevious = () => {
    onChange(value.subtract(1, 'month'))
  }

  const handleNext = () => {
    onChange(value.add(1, 'month'))
  }

  return (
    <StyledMonthPicker>
      <StyledMonthPickerIconButton aria-label="Previous" size="small" onClick={handlePrevious}>
        <ChevronLeft />
      </StyledMonthPickerIconButton>

      <StyledMonthAndYearContainer>
        <Typography variant="body1" fontWeight={700} sx={{ color: 'text.highEmphasis', textTransform: 'capitalize' }}>
          {value.locale(i18n.language).format(DateFormat.MonthName)}
        </Typography>
        <Typography variant="subtitle2" component="p" fontWeight={400} sx={{ color: 'text.base' }}>
          {value.format(DateFormat.Year)}
        </Typography>
      </StyledMonthAndYearContainer>

      <StyledMonthPickerIconButton aria-label="Next" size="small" onClick={handleNext}>
        <ChevronRight />
      </StyledMonthPickerIconButton>
    </StyledMonthPicker>
  )
}

export default LocalMonthPicker
